// import { TableHead, TableRow, TableCell, Box, Checkbox } from '@mui/material';
// import { visuallyHidden } from '@mui/utils';
// import TableSortLabel from '@mui/material/TableSortLabel';

// export const TableHeader = (props) => {
//     const { order, orderBy, dataCount, onRequestSort, headData, onSelectAllClick, numSelected, titleKeys=[] } = props;
//     const createSortHandler = (property) => (event) => {
//         onRequestSort(event, property);
//     };

//     const lableHandler = (title) => {
//         let newwrap="nowrap"
//         titleKeys?.forEach((items) => {
//             if (title === items) {
//                 newwrap = "wrap"
//             }
//         })
//         return newwrap
//     }
//     return (
//         <TableHead sx={{}} >
//             <TableRow >
//                 {onSelectAllClick && <TableCell >
//                     <Checkbox
//                         color="primary"
//                         // indeterminate={numSelected > 0 && numSelected < dataCount}
//                         checked={dataCount > 0 && numSelected === dataCount}
//                         onChange={onSelectAllClick}
//                         inputProps={{ "aria-label": "select all desserts" }}
//                     />
//                 </TableCell>}
//                 {headData.map((headCell, index) => (
//                     <TableCell

//                         key={headCell.id}
//                         align={headCell.label === "Action" ? 'right' : headCell.label === "Status" ? "right" : "left"}
//                         sortDirection={orderBy === headCell.id ? order : false}
//                         sx={{ color: "#fff" }}
//                     >
//                         <TableSortLabel
//                             active={orderBy === headCell.id}
//                             direction={orderBy === headCell.id ? order : 'asc'}
//                             onClick={headCell.isShorted === true ? createSortHandler(headCell.id) : null}
//                             sx={
//                                 {
//                                     '&.MuiTableSortLabel-root': {
//                                         color: '#fff',
//                                     },
//                                     '&.MuiTableSortLabel-root:hover': {
//                                         color: '#fff',
//                                     },
//                                     '&.Mui-active': {
//                                         color: '#FFF',
//                                     },
//                                     '& .MuiTableSortLabel-icon': {
//                                         color: `${headCell.isShorted === true ? "#fff" : "#103a4000"}  !important`,
//                                     },
//                                     whiteSpace: `${lableHandler(headCell.label) } `
//                                 }
//                             }

//                         >

//                             {headCell.label}
//                             {orderBy === headCell.id ? (
//                                 <Box component="span" sx={visuallyHidden}>
//                                     {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
//                                 </Box>
//                             ) : null}
//                         </TableSortLabel>
//                     </TableCell>
//                 ))}
//             </TableRow>
//         </TableHead >
//     );
// }

import { TableHead, TableRow, TableCell, Box, Checkbox } from '@mui/material'
import { visuallyHidden } from '@mui/utils'
import TableSortLabel from '@mui/material/TableSortLabel'

export const TableHeader = (props) => {
    const { order, orderBy, dataCount, onRequestSort, headData, onSelectAllClick, numSelected, titleKeys = [] } = props

    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property)
    }

    const labelHandler = (title) => {
        let newWrap = 'nowrap'
        titleKeys?.forEach((items) => {
            if (title === items) {
                newWrap = 'wrap'
            }
        })
        return newWrap
    }

    return (
        <TableHead
            sx={{
                '& .MuiTableRow-root': {
                    padding: '5px',
                },
                '& .MuiTableCell-root': {
                    padding: '8px 8px', // Adjust cell padding
                    fontSize: '11px', // Adjust font size
                    lineHeight: '1', // Adjust line height
                    backgroundColor: '#103a40', // Optional: adjust header background color
                    color: '#fff', // Header font color
                },
            }}
        >
            <TableRow>
                {onSelectAllClick && (
                    <TableCell>
                        <Checkbox
                            color="primary"
                            checked={dataCount > 0 && numSelected === dataCount}
                            onChange={onSelectAllClick}
                            inputProps={{ 'aria-label': 'select all desserts' }}
                        />
                    </TableCell>
                )}
                {headData.map((headCell, index) => (
                    <TableCell
                        key={`headCell?.label - ${index}`}
                        // align={
                        //     headCell.label === "Action" ? 'right' :
                        //         headCell.label === "Status" ? "right" : "left"
                        // }
                        sortDirection={orderBy === headCell.id ? order : false}
                        sx={{
                            color: '#fff',
                        }}
                        style={{ borderRight: '1px solid #e0e0e0' }}
                    >
                        <TableSortLabel
                            key={index}
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={headCell.isShorted === true ? createSortHandler(headCell.id) : null}
                            sx={{
                                '&.MuiTableSortLabel-root': {
                                    color: '#fff',
                                    fontSize: '12px', // Adjust font size
                                    lineHeight: '1.2', // Adjust line height
                                },
                                '&.MuiTableSortLabel-root:hover': {
                                    color: '#fff',
                                },
                                '&.Mui-active': {
                                    color: '#FFF',
                                },
                                '& .MuiTableSortLabel-icon': {
                                    color: `${headCell.isShorted === true ? '#fff' : '#103a4000'}  !important`,
                                },
                                whiteSpace: `${labelHandler(headCell.label)} `,
                            }}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box key={index} component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}
